import { createSlice } from "@reduxjs/toolkit";

const filterSlice = createSlice({
  name: "filter",
  initialState: {
    selectedDataRef: new Date().toISOString().split('T')[0],
    paginationModel: { pageSize: 10, page: 0, totalPages: 1 },
  },
  reducers: {
    setSelectedDataRef: (state, action) => {
      state.selectedDataRef = action.payload;
    },
    setPaginationModel: (state, action) => {
      const { pageSize, page, totalPages } = action.payload;
      state.paginationModel.pageSize = pageSize;
      state.paginationModel.page = page;
      state.paginationModel.totalPages = totalPages;
    },
  },
});

export const {
  setSelectedDataRef,
  setPaginationModel,
} = filterSlice.actions;

export default filterSlice.reducer;
